import { render, staticRenderFns } from "./SmartGrowthDetail.vue?vue&type=template&id=668a13b0&scoped=true&"
import script from "./SmartGrowthDetail.vue?vue&type=script&lang=js&"
export * from "./SmartGrowthDetail.vue?vue&type=script&lang=js&"
import style0 from "./SmartGrowthDetail.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./SmartGrowthDetail.vue?vue&type=style&index=1&id=668a13b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668a13b0",
  null
  
)

export default component.exports